<template>
	<div>
		<!-- 添加或修改对话框 -->
		<el-dialog title="修改网站基本信息" :visible.sync="open" :close-on-click-modal="false" width="800px" append-to-body :before-close="cancel">
			<el-form ref="form" :model="form" :rules="rules" label-width="120px">
				<el-row>
					<el-col :span="12">
						<el-form-item label="标题" prop="title"><el-input v-model="form.title" placeholder="请输入标题" /></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="关键词" prop="keyword"><el-input v-model="form.keyword" placeholder="请输入关键词" /></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="单位名称" prop="organName"><el-input v-model="form.organName" placeholder="请输入单位名称" /></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="电话" prop="phone"><el-input v-model="form.phone" placeholder="请输入电话" /></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="传真" prop="fax"><el-input v-model="form.fax" placeholder="请输入传真" /></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="邮编" prop="zipCode"><el-input v-model="form.zipCode" placeholder="请输入邮编" /></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="备案号" prop="internetContentProvider"><el-input v-model="form.internetContentProvider" placeholder="请输入备案号" /></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="京公网安备案号" prop="jingNetworkSecurityNumber">
							<el-input v-model="form.jingNetworkSecurityNumber" placeholder="请输入京公网安备案号" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="悬浮开关" prop="suspend"><el-switch v-model="form.suspend" active-value="1" inactive-value="0"></el-switch></el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="描述信息" prop="description">
							<el-input type="textarea" :rows="2" placeholder="请输入描述信息" v-model="form.description"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="cancel">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: {
		open: {
			type: Boolean,
			default: false
		},

		form: {
			type: Object
		}
	},
	data() {
		return {
			rules: {
				title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				keyword: [{ required: true, message: '请输入关键词', trigger: 'blur' }],
				organName: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
				phone: [{ required: true, message: '请输入电话', trigger: 'blur' }]
			}
		};
	},
	
	methods: {
		submitForm() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.$http
						.post('/sys/params/saveWebBaseInfo', this.form)
						.then(({ data: res }) => {
							if (res.code !== 0) {
								return this.$message.error(res.msg);
							}
							this.$message({
								message: this.$t('prompt.success'),
								type: 'success',
								duration: 500,
								onClose: () => {
									this.$emit('submitForm');
								}
							});
						})
						.catch(() => {});
				}
			});
		},
		cancel() {
			this.$emit('cancel');
		},
		
	}
};
</script>

<style></style>
